var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"pagination__btns"},_vm._l((_vm.allSlides - _vm.shiftSlides),function(index){return _c('li',{key:index,attrs:{"value":index}},[_c('button',{class:{ active: _vm.currentSlide === index - 1 },on:{"click":function($event){return _vm.setSlide(index - 1)}}},[_vm._v(" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }